<template>
  <div class="mirror-container">
    <div
      v-show="showModal"
      class="mirror-bg"
      :style="`background-color: ${overlayColor}`"
      @click="close"
    ></div>
    <p style="position: fixed; display: inline-block">adsa</p>
    <div id="mirror" class="normal" :class="{ maximized: maximized }">
      <video v-show="!loading" ref="video" id="video" width="100%" height="100%" autoplay></video>
    </div>
  </div>
</template>

<script>
export default {
  name: "mirror",
  data() {
    return {
      showModal: false,
      maximized: false,
      video: {},
      canvas: {},
      captures: [],
      loading: true,
      status: "",
      overlayColor: "rgba(0, 0, 0, 0)"
    };
  },
  methods: {
    stopTracks(tracks) {
      if (tracks) {
        tracks
          .getTracks() // get all tracks from the MediaStream
          .forEach(track => track.stop()); // stop each of th
      }
    },
    close() {
      this.showModal = false;
      this.stopTracks(this.video.srcObject);
      this.overlayColor = "rgba(0, 0, 0, 0)";
      this.$emit("close");
    },
    toggleSize() {
      this.maximized = !this.maximized;
    }
  },
  beforeDestroy() {
    this.stopTracks(this.video.srcObject);
  },
  mounted() {
    setTimeout(() => {
      this.overlayColor = "rgba(0, 0, 0, 0.8)";
    }, 10);
    this.showModal = true;
    this.video = this.$refs.video;
    let self = this;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then(stream => {
          self.loading = false;
          self.video.srcObject = stream;
          self.video.play();
          this.$notify.info({
            title: "比較モード",
            message: "暗い画面部分を選択すると終了できます。"
          });
        })
        .catch(err => {
          self.loading = false;
          self.$notify.error({
            title: "エラー",
            message: "カメラを使用することができません。"
          });
        });
    }
  }
};
</script>

<style lang="scss">
.mirror-container {
  position: relative;
  overflow: hidden;
  /* z-index: 100000; */
}

.mirror-bg {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 109;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0);
  transition: background-color 0.5s ease;
}
#mirror {
  z-index: 140;
  left: 0;
  position: absolute;
  box-shadow: 0 0 30px 10px rgba(106, 128, 150, 0.2);
  overflow: hidden;
  display: block;
  width: 100%;
  height: 100%;
  transform: scale(1.4);
  background-color: #fff;
}
.maximized {
  width: 640px !important;
  height: 480px !important;
}
.normal {
  width: 448px;
  height: 336px;
  transition: height 0.3s ease, width 0.3s ease;
}

#video {
  background-color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#canvas {
  display: none;
}
li {
  display: inline;
  padding: 5px;
}
</style>
